
























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import moment from "moment";
import { MANAGE_SPACE_OPTIONS } from "@/resources/constants/sidebarMenu";
@Component({
  name: "speed-networking-component",
})
export default class SpeedNetworkingComponent extends mixins(
  NotificationEvent
) {
  loadingSendEmail = false;
  speedNetworkingCycleTime = 0;
  interval = null;
  stopCall = true;
  waitingCycleTime = 0;
  waitingInterval = null;
  beetWenInterval = null;
  beetWenCyCleTime = 0;
  isBeetWenTime = false;
  meetingId = null;
  get active() {
    return this.$store.getters["SpeedNetworkingStore/getEnterInNetworking"];
  }
  get waiting() {
    const waiting =
      this.$store.getters["SpeedNetworkingStore/getWaitingMeeting"];
    /*if (!waiting) {
      this.openGame();
    }*/
    return waiting;
  }
  set waiting(e) {
    this.$store.dispatch("SpeedNetworkingStore/setWaitingMeetingAction", e);
  }
  get userConnection() {
    return this.$store.getters["SpeedNetworkingStore/getUserInMeeting"];
  }
  set userConnection(e) {
    this.$store.dispatch("SpeedNetworkingStore/setUserInMeetingAction", e);
  }
  get usersInCall() {
    return this.$store.getters["MeetingStore/getUsersInCall"];
  }
  get waitingTime() {
    const time = this.$store.getters["SpeedNetworkingStore/getWaitingTime"];

    if (time) {
      const split = time.split(":");
      const timerMs =
        parseInt(split[0]) * 3600000 +
        parseInt(split[1]) * 60000 +
        parseInt(split[2]) * 1000;
      return timerMs;
    } else return null;
  }
  get beetWenTime() {
    return (
      parseInt(
        localStorage.getItem("SPEED_NETWORKING_WAITING_TIME_BETWEEN_CYCLES")
      ) * 1000
    );
  }
  get meetingTime() {
    const time = this.$store.getters["SpeedNetworkingStore/getMeetingTime"];
    if (time) {
      const split = time.split(":");
      const timerMs =
        parseInt(split[0]) * 3600000 +
        parseInt(split[1]) * 60000 +
        parseInt(split[2]) * 1000;
      return timerMs - this.beetWenTime;
    } else return null;
  }
  sendInfoEmail() {
    this.loadingSendEmail = true;
    const space = this.$store.getters["SpaceStore/getSpace"] as SpaceInterface;
    if (!space) return;
    this.$store.dispatch("SpaceStore/sendInfoUserAction", {
      spaceId: space.id,
      userId: this.userConnection.id,
      callback: () => {
        this.loadingSendEmail = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.sendInfoEmail")
        );
      },
      callbackError: () => {
        this.loadingSendEmail = false;
        this.onError(
          i18n.t("notifications.titles.error"),
          i18n.t("notifications.genericError.genericErrorRetry")
        );
      },
    });
  }
  @Watch("active")
  restart() {
    clearInterval(this.interval);
    clearInterval(this.waitingInterval);
    this.interval = null;
    this.waitingInterval = null;
    this.waiting = true;
    this.userConnection = null;
  }

  @Watch("waiting")
  start() {
    if (this.waiting) {
      clearInterval(this.interval);
      this.interval = null;
      this.speedNetworkingCycleTime = this.meetingTime;
      this.stopCall = true;
      this.startWaitingTime();
    } else {
      this.isBeetWenTime = false;
      this.speedNetworkingCycleTime = this.meetingTime;
      const timer = document.getElementById("timer");
      if (timer)
        timer.innerText = moment(this.speedNetworkingCycleTime).format("mm:ss");

      this.interval = setInterval(() => {
        const timer = document.getElementById("timer");
        if (this.speedNetworkingCycleTime <= 0) {
          clearInterval(this.interval);
          this.interval = null;
          this.startBeetWenTime();
        }
        if (timer) {
          if (this.speedNetworkingCycleTime <= 30000)
            timer.setAttribute("style", "color:red");
          const audio = new Audio(require("@/assets/audio/beep.mp3"));
          audio.volume = 0.4;
          switch (this.speedNetworkingCycleTime) {
            case 30000: {
              audio.play();
              break;
            }
            case 20000: {
              audio.play();
              setTimeout(() => audio.play(), 500);
              break;
            }
            case 10000: {
              audio.play();
              setTimeout(() => audio.play(), 500);
              setTimeout(() => audio.play(), 1000);
              break;
            }
          }
          timer.innerText = moment(this.speedNetworkingCycleTime).format(
            "mm:ss"
          );
          this.speedNetworkingCycleTime -= 1000;
        }
      }, 1000);
    }
  }
  startBeetWenTime() {
    this.beetWenCyCleTime = this.beetWenTime;

    const meeting = this.$store.getters["MeetingStore/getMeeting"];
    this.meetingId = meeting ? meeting.MeetingId : null;
    this.$store.dispatch("SidebarStore/setOpenCall", false);
    this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
    this.$store.dispatch("SpeedNetworkingStore/setUserInMeetingAction", null);
    this.$store.dispatch("MeetingStore/closeMeetingSession");
    this.isBeetWenTime = true;

    const timer = document.getElementById("timer");
    this.beetWenInterval = setInterval(() => {
      this.beetWenCyCleTime -= 1000;
      if (this.beetWenCyCleTime <= 0) {
        this.nextMeeting();
        clearInterval(this.beetWenInterval);
        this.beetWenInterval = null;
      }
      timer.innerText = moment(this.beetWenCyCleTime).format("mm:ss");
    }, 1000);
  }
  nextMeeting() {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    if (this.meetingId)
      this.$store.dispatch(
        "SpeedNetworkingStore/changeCycleSpeedNetworkingAction",
        {
          roomId,
          speedNetworkingMeetingId: this.meetingId,
          callback: () => {
            // do nothing
          },
        }
      );
  }
  openInfoModal() {
    this.$store.dispatch(
      "SystemStore/setUserInfoIdAction",
      this.userConnection.superSpaceUser.id
    );

    this.$store.dispatch("SystemStore/setOpenUserInfoModalAction", true);
  }
  openGame(): void {
    this.$store.dispatch("MeetingStore/setActiveGameAction", true);
  }
  onStopCall() {
    if (this.stopCall) {
      this.stopCall = false;
      this.$store.dispatch("MeetingStore/closeMeetingSession");
      this.$store.dispatch("SidebarStore/setOpenCall", false);
      this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
    }
  }
  @Watch("active")
  startWaitingTime(): void {
    if (this.waitingInterval != null) return;
    setTimeout(() => {
      if (this.waitingTime && this.active && this.waiting) {
        const timerWait = document.getElementById("timer-waiting");
        const now = moment().valueOf();
        this.waitingCycleTime = this.waitingTime;
        if (this.waitingCycleTime >= 0)
          this.waitingInterval = setInterval(() => {
            if (this.waitingCycleTime <= 0) {
              clearInterval(this.waitingInterval);
              this.waitingInterval = null;
              this.checkWaitingEnd();
            }
            timerWait.innerText = moment(this.waitingCycleTime).format("mm:ss");

            this.waitingCycleTime -= 1000;
          }, 1000);
      }
    }, 500);
  }
  checkWaitingEnd(): void {
    setTimeout(() => {
      if (this.waiting) {
        const roomId = this.$store.getters["MeetingStore/getRoomId"];
        if (roomId !== 0) {
          this.$store.dispatch("SpaceStore/getRoomAction", {
            roomId: roomId,
            callback: (data) => {
              this.$store.dispatch(
                "SpeedNetworkingStore/setWaitingTimeAction",
                data.nextSpeedNetworkingCycleTime
              );
              this.startWaitingTime();
            },
            callbackError: () => {
              // do nothing
            },
          });
        }
      }
    }, 3000);
  }
}
